import { Alert } from '@ps/isp-web-component-library';
import { ImplyRunnerFailureCode } from '@ps/isp-web-services-types';
import type { TranslationTag } from '@ps/web-core-intl';
import { useTrackers } from '@ps/web-shared-analytics';
import { Translation, useTrackingLabel } from '@ps/web-shared-components';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import {
  TXTWCL_Add_a_selection_that_is_not_co_ELL,
  TXTWCL_There_is_at_least_one_selectio_ELL,
  TXTWCL_This_bet_cannot_be_placed_due__ELL
} from './BetBuilderError.messages.json';

export interface Props {
  failureCode?: ImplyRunnerFailureCode;
  className?: string;
}

const impossibleOutcomeFailureCodes: ImplyRunnerFailureCode[] = [
  ImplyRunnerFailureCode.INVALID_SGM_COMBINATION,
  ImplyRunnerFailureCode.IMPOSSIBLE_SAME_MARKET_COMBINATION
];
const guaranteedOutcomeFailureCode = ImplyRunnerFailureCode.INVALID_SGM_COMBINATION_SINGLE_ODDS;

const BetBuilderError: React.FC<Props> = ({ failureCode, className }) => {
  const { formatMessage } = useIntl();
  const { errorViewed, panelToggled } = useTrackers();
  const panelNameLabel = useTrackingLabel(TXTWCL_Add_a_selection_that_is_not_co_ELL);
  let errorTranslationTag: TranslationTag | undefined;

  useEffect(() => {
    failureCode && errorViewed({ errorCode: failureCode });
  }, [failureCode, errorViewed]);

  if (failureCode && impossibleOutcomeFailureCodes.includes(failureCode)) {
    errorTranslationTag = TXTWCL_This_bet_cannot_be_placed_due__ELL;
  }

  if (failureCode === guaranteedOutcomeFailureCode) {
    return (
      <div className={className}>
        <Alert
          title={formatMessage(TXTWCL_Add_a_selection_that_is_not_co_ELL)}
          level="destructive"
          variant="passive-aggressive"
          isCollapsible
          isInitiallyExpanded={false}
          isSquare
          onToggle={(isExpanded: boolean) =>
            panelToggled({
              panelName: panelNameLabel,
              isOpen: isExpanded
            })
          }
        >
          <Translation {...TXTWCL_There_is_at_least_one_selectio_ELL} />
        </Alert>
      </div>
    );
  }

  if (errorTranslationTag) {
    return (
      <div className={className}>
        <Alert level="warning">
          <Translation {...errorTranslationTag} />
        </Alert>
      </div>
    );
  }

  return null;
};

export default BetBuilderError;
